module.exports = __webpack_public_path__ + "img/title-bg.28933a1c.png";